module.exports = __webpack_public_path__ + "static/media/CMHA.936a51ee.png";